/**
 * A global namespace for 'transitionDelay' string.
 */
const transitionDelay = "transitionDelay";
export default transitionDelay;
